import React from 'react';
import { Typography, Box, Paper } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function Admin() {
  const { t } = useTranslation();
  return (
    <Box sx={{ p: 4, maxHeight: '70vh', overflow: 'auto' }}>
      <Paper elevation={2} sx={{ p: 3 }}>
        <Typography variant="h4">{t('admin.title')}</Typography>
        <Typography>{t('admin.description')}</Typography>
      </Paper>
    </Box>
  );
}
